import React, { useEffect } from 'react'
import { Alert } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../redux/store'
import AppModal from '../common/AppModal'
import CreateExpenseForm from '../../forms/CreateExpenseForm'
import { getExpenseCategories } from '../../redux/actions/expenseCategoryActions'
import { getPaymentMethods } from '../../redux/actions/paymentMethodActions'
import { checkCashierHasOpenShift, getCurrentOrRecentShift } from '../../redux/actions/shiftActions'

const CreateExpenseModal: React.FC<{
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}> = ({ open, onClose, loading, error }) => {
  const dispatch = useAppDispatch()
  const { hasOpenShift, currentShift } = useAppSelector((state) => state.shift)

  useEffect(() => {
    if (open) {
      dispatch(getExpenseCategories({ size: 20 }))
      dispatch(getPaymentMethods({ size: 20 }))
      dispatch(checkCashierHasOpenShift())
    }
  }, [dispatch, open])

  useEffect(() => {
    if (open && hasOpenShift) dispatch(getCurrentOrRecentShift())
  }, [dispatch, open, hasOpenShift])

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Record Business Expense"
      width="md"
      loading={loading}
    >
      {hasOpenShift && (
        <Alert severity="info" sx={{ mb: 3 }}>
          An active shift was detected. This expense will be linked to Shift #
          {currentShift?.id?.split('-')[0]}.
        </Alert>
      )}

      <CreateExpenseForm
        // Pass shiftId if a shift is open, otherwise pass null
        shiftId={hasOpenShift ? currentShift?.id : null}
        loading={loading}
        error={error}
      />
    </AppModal>
  )
}
export default CreateExpenseModal
